export default {"src":"/_next/static/media/cart-solid-navy.42d06e9b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};